import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import NRActionModal from '../../../NRActionModal/NRActionModal';
import {
  getUnlinkModalMessage,
  getUnlinkModalTitle,
  VULNERABILITY_JIRA_TICKETS_LABELS
} from './vulnerabilityJiraTickets.constants';

function NRJiraUnlinkTicketModal({ open, ticket, onClose, onConfirm, isSubmitting = false }) {
  if (!ticket) {
    return null;
  }

  return (
    <NRActionModal
      title={getUnlinkModalTitle(ticket.ticketKey)}
      actionLabel={VULNERABILITY_JIRA_TICKETS_LABELS.UNLINK_MODAL_CONFIRM}
      cancelLabel={VULNERABILITY_JIRA_TICKETS_LABELS.UNLINK_MODAL_CANCEL}
      open={open}
      handleClose={onClose}
      handleCancelAction={onClose}
      handleConfirmAction={onConfirm}
      actionDisabled={isSubmitting}
      cancelButtonProps={{ variant: 'outlined', color: 'secondary', disabled: isSubmitting }}
      actionButtonProps={{
        variant: 'contained',
        color: 'secondary',
        endIcon: isSubmitting ? <CircularProgress size={16} color="inherit" /> : null
      }}
      width={520}
      content={<Typography variant="body1">{getUnlinkModalMessage(ticket.ticketKey)}</Typography>}
    />
  );
}

export default NRJiraUnlinkTicketModal;
